<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <h4 class="cart__title cart__title--mb" id="cart__customer-title">Seus Dados de Contato</h4>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <div class="form-group">
          <label for="cart-name" ref="cart-name">Nome</label>

          <input
            type="text"
            name="name"
            @input="updateName"
            ref="cart-name"
            v-validate="'required'"
            class="form-control"
            :class="{'error': errors.has('name')}"
            id="cart-name"
            autocapitalize="off"
            autocomplete="off"
            autocorrect="off"
          />

          <span class="vee-error">{{errors.first('name')}}</span>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group">
          <label for="cart-email" ref="cart-email">Email</label>

          <input
            type="email"
            name="email"
            @input="updateEmail"
            ref="cart-email"
            v-validate="'required|email'"
            class="form-control"
            :class="{'error': errors.has('email')}"
            id="cart-email"
            autocapitalize="off"
            autocomplete="off"
            autocorrect="off"
          />

          <span class="vee-error">{{errors.first('email')}}</span>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="form-group">
          <label for="cart-telefone" ref="cart-telefone">Telefone</label>

          <input
            type="tel"
            name="telefone"
            @input="updatePhone"
            v-mask="['(##) ####-####', '(##) #####-####']"
            ref="cart-telefone"
            v-validate="'required'"
            class="form-control"
            :class="{'error': errors.has('telefone')}"
            id="cart-telefone"
            autocapitalize="off"
            autocomplete="off"
            autocorrect="off"
          />

          <span class="vee-error">{{errors.first('telefone')}}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-8">
        <div class="form-group">
          <label for="notes">
            Observações
            <small>(Opcional)</small>
          </label>
          <textarea @input="updateNote" class="form-control" id="notes" rows="3"></textarea>
        </div>
      </div>

      <div class="col-lg-4">
        <a href="#" @click.prevent="saveQuotation" class="cart__btn-budget">Solicitar Orçamento</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import * as types from "../store/mutation-types";

export default {
  name: "Customer",

  inject: ["$validator"],

  methods: {
    ...mapMutations("cart", {
      updateName: types.UPDATE_NAME,
      updateEmail: types.UPDATE_EMAIL,
      updatePhone: types.UPDATE_PHONE,
      updateNote: types.UPDATE_NOTE
    }),

    saveQuotation() {
      bus.$emit("cart/saveQuotation");
    }
  }
};
</script>

